<template>
    <v-text-field class="center-aligned"
    flat solo dense hide-details readonly background-color="blue-grey darken-3"
    :prefix="label + ':'" 
    :value="formatDate(value)"
    ></v-text-field>
</template>
<script>
export default {
    name: 'DateTimeView',
    props: ['label', 'format', 'name', 'value'],
    data: () => ({
    }),
    computed: {
    },
    mounted() {
    },
    methods: {
        formatDate (datetime) {
            if (!datetime || datetime.search("-") < 0) return null
            const [date, time] = datetime.split(' ')
            const [year, month, day] = date.split('-')
            const [hours, minutes, seconds] = time.split(':')
            const d = new Date(year, month - 1, day, hours, minutes, seconds)
            return d.toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", })
        },
    },
}
</script>
<style scoped>
.center-aligned >>> input {
    text-align: center
}
</style>